export const DELETE_CREDIT = 'DELETE_CREDIT';
export const GET_CREDITS_BEGIN = 'GET_CREDITS_BEGIN';
export const GET_CREDITS_SUCCESS = 'GET_CREDITS_SUCCESS';
export const GET_CREDIT_BY_ID_SUCCESS = 'GET_CREDIT_BY_ID_SUCCESS';
export const SELECT_CREDIT = 'SELECT_CREDIT';
export const SET_SELECTED_CREDIT_FIELD = 'SET_SELECTED_CREDIT_FIELD';
export const SELECT_CREDIT_FOR_DROPDOWN = 'SELECT_CREDIT_FOR_DROPDOWN';
export const GET_CREDITS_SUCCESS_FOR_DROPDOWN = 'GET_CREDITS_SUCCESS_FOR_DROPDOWN';
export const SET_CALCULATION_MODAL_STATE = 'SET_CALCULATION_MODAL_STATE';
